const StatusTypes = {
  INACTIVE: "INACTIVE",
  ACTIVE: "ACTIVE",
  DELETED: "DELETED",
};

export default StatusTypes;
